import { render } from "./Block.vue?vue&type=template&id=19627d59&scoped=true"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&id=19627d59&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19627d59"]])

export default __exports__